<div *ngIf="!isDarkMode()" class="container">
  <iframe
    class="database"
    src="https://lookerstudio.google.com/embed/reporting/74dd9690-e5bd-44de-bc04-9d86dac2c61a/page/p_7zbyp5hy7c"
    frameborder="0"
    style="border: 0"
    allowfullscreen
    sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
  ></iframe>
</div>
<div *ngIf="isDarkMode()" class="container">
  <iframe
    class="database"
    src="https://lookerstudio.google.com/embed/reporting/fc7a58c2-846d-4567-8ed2-7adaf4d75aee/page/p_7zbyp5hy7c"
    frameborder="0"
    style="border: 0"
    allowfullscreen
    sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
  ></iframe>
</div>
